import { render, staticRenderFns } from "./CustomSzwtProcessPointsList.vue?vue&type=template&id=a53cdef0&scoped=true&"
import script from "./CustomSzwtProcessPointsList.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtProcessPointsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomSzwtProcessPointsList.vue?vue&type=style&index=0&id=a53cdef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53cdef0",
  null
  
)

export default component.exports